import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { useEnum } from "@/api/services/global/enum";
import { useGetResidenceStatusList } from "@/api/services/global/master";
import { JobInfoItem } from "@/features/job/components/job-detail/JobInfoItem";
import { findLabelByValue, findLabelsByValue } from "@/utils/object";
import { state } from "@/theme/colors";

type JobRequirementDetailProps = {
  defaultValues?: Partial<TJobForm>;
  isDraft?: boolean;
};

export const JobRequirementDetail: FC<JobRequirementDetailProps> = ({ defaultValues, isDraft }) => {
  const { data: japaneseLevelTypeOptions } = useEnum("EJapaneseLevelType");
  const { data: recruitmentLocationTypeOptions } = useEnum("ERecruitmentLocationType");
  const { data: genderOptions } = useEnum("EGender");
  const { data: specifiedSkillPassedOptions } = useEnum("ESpecifiedSkillPassed");
  const { residenceStatusOptions } = useGetResidenceStatusList();

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="応募要件" />} padding="24px" showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <JobInfoItem label="必要な日本語レベル" value={findLabelByValue(japaneseLevelTypeOptions, defaultValues?.japaneseLevelType)} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="必要な日本語レベル（その他）" value={defaultValues?.japaneseLevelOther} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="必要な技能・経験" value={defaultValues?.skillsExperience} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="その他応募要件" value={defaultValues?.otherApplicationRequirements} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="年齢制限（上限）" value={defaultValues?.ageLimit} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="国籍" value={defaultValues?.nationalities?.map(item => item.nationalityName).join("、")} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="募集地" value={findLabelByValue(recruitmentLocationTypeOptions, defaultValues?.recruitmentLocationType)} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="採用希望時期" value={defaultValues?.desiredHiringPeriod} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="性別" value={findLabelByValue(genderOptions, defaultValues?.gender)} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="在留資格" value={findLabelsByValue(residenceStatusOptions, defaultValues?.residenceStatusIds ?? [])} required={!isDraft} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="特定技能試験合格" value={findLabelsByValue(specifiedSkillPassedOptions, defaultValues?.specifiedSkillPassed ?? [])} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="求人票（URL）" value={defaultValues?.jobDocumentUrl} color={state.link_1} type="link" />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="求人票（ファイル添付）" value={defaultValues?.jobDocumentFilePath} type="file" />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="選考フロー" value={defaultValues?.selectionProcess} isShowDivider={false} />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
